import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import PrimaryBox from 'components/Motion_Detection/Alarm_Server/PrimaryBox';
import ForumBox from 'components/Motion_Detection/Alarm_Server/ForumBox';
import NavButtons from 'components/Motion_Detection/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  PrimaryBox,
  ForumBox,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};